import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { ITournament } from "@/types"
import settings from "@/settings/public"

interface UseTournamentsProps {
  params?: any
  options?: Omit<UseQueryOptions<ITournament[], Error>, 'queryKey' | 'queryFn'>
}

const getPlaceholderData = (index: number): ITournament => {
  return {
    "id": `placeholder-${index}`,
    "_id": `placeholder-${index}`,
    "name": {
      "original": `Tournament ${index + 1}`,
      "es": `Torneo ${index + 1}`
    },
    "icon": `placeholder-${index}`,
    "imageUrl": "",
    "__children": null,
    "__belong": null
  }
}

const fetchTournaments = async (appCode: string) => {
  const baseUrl = `${settings.api.host}/api/1.0/sport/tournaments?paginate=false`
  const url = appCode ? `${baseUrl}&filterBy-apps.appCode=${appCode}` : baseUrl

  const response = await fetch(url)
  const tournamentsList = await response.json()
  if (tournamentsList.error) {
    throw tournamentsList.error
  }

  return tournamentsList.data.items
}

export function useTournaments({
  params,
  options = {}
}: UseTournamentsProps = {}) {
  const appCode = params?.appCode || settings.app.code!

  const { data, isLoading, isError, isFetching, isPlaceholderData } = useQuery({
    queryKey: ["tournaments", ...(appCode ? [appCode] : [])],
    queryFn: () => fetchTournaments(appCode),
    staleTime: Infinity,
    placeholderData: Array.from({ length: 4 }, (_, index) => getPlaceholderData(index)),
    ...options
  })

  return {
    data: data ?? [],
    isLoading,
    isError,
    isFetching,
    isPlaceholderData,
    isEmpty: !isLoading && data?.length === 0
  }
}